import { FormattedMessage } from "react-intl"
import { FormSelect } from "@/components/Form/FormSelect"
import { useGetFreightForwarderInfoQuery } from "@/client/freight-forwarder-info/freightForwarderInfoApi"
import { FormTextInput } from "@/components/Form/FormTextInput"
import { type TransportDetailsFormInput } from "./TransportDetailsPanel"

export const FreightForwarderDetails = () => {
    const { data, error, isLoading } = useGetFreightForwarderInfoQuery()

    return <div
        className="margin-bottom-15 align-items-center justify-content-center padding-top-20 padding-bottom-5 padding-x-20 bg-lightest">
        <div className={"display-flex gap-20 margin-bottom-15"}>
            <div className={"flex-basis-100pct"}>
                <FormSelect
                    fieldName={"transportDetails.freightForwarder.duns"}
                    label={<FormattedMessage id={"carrier.duns"}/>}
                    options={(data?.dunsNumbers ?? []).map(duns => ({ id: duns, label: duns, }))}
                    disabled={isLoading || error !== undefined}
                    required={true}
                    validationMessageOverrides={{
                        required: <FormattedMessage id={"freightPaymentDetails.carrier.duns.required"}/>
                    }}
                />
            </div>
            <div className={"flex-basis-100pct"}>
                <FormTextInput<TransportDetailsFormInput>
                    fieldName={"transportDetails.freightForwarder.supplierCode"}
                    label={<FormattedMessage id={"carrier.supplierCode"}/>}
                    required={true}
                    validationMessageOverrides={{
                        required: <FormattedMessage id={"freightPaymentDetails.carrier.supplierCode.required"}/>
                    }}
                />
            </div>
        </div>
        <div className={"display-flex gap-20 margin-bottom-15"}>
            <div className={"flex-basis-100pct"}>
                <FormTextInput<TransportDetailsFormInput>
                    fieldName={"transportDetails.borderoNumber"}
                    label={<FormattedMessage id={"transportOrder.confirmation.input.label.bordero"}/>}
                    required={true}
                    minLength={1}
                    maxLength={17}
                    validationMessageOverrides={{
                        required: <FormattedMessage id={"freightPaymentDetails.borderoNumber.required"}/>,
                        maxLength: <FormattedMessage id={"validation.length.max"} values={{ num: 17 }}/>
                    }}
                />
            </div>
            <div className={"flex-basis-100pct"}>
                <FormTextInput<TransportDetailsFormInput>
                    fieldName={"transportDetails.accessCode"}
                    label={<FormattedMessage id={"transportOrder.shipment.address.accessCode"}/>}
                    required={false}
                />
            </div>
        </div>
    </div>
}
